import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { useParams } from 'quartz-routing/react-router';
import { NavMarker } from 'react-rhumb';
import { Subscreens } from '../../constants/usage';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { NoResults } from './NoResults';
import { ResultsGridWithSummary } from './ResultsGridWithSummary';
import { ResultsGridWithoutSummary } from './ResultsGridWithoutSummary';
import { useProductTypes } from '../../hooks/useProductTypeSearchParams';
import { jsx as _jsx } from "react/jsx-runtime";
export function ResultsGrid() {
  const productTypes = useProductTypes();
  const {
    loading,
    data,
    error
  } = useSearchResultsQuery();
  const hasAi = (data === null || data === void 0 ? void 0 : data.result.aiAnswer) || (data === null || data === void 0 ? void 0 : data.result.aiRequestId);
  const hideAi = !productTypes.some(pt => pt === 'APP' || pt === 'AGENT');
  if (loading) return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true,
    size: "medium",
    marginBlockStart: "800"
  });
  if (error) return /*#__PURE__*/_jsx(ErrorMessage, {
    type: "badRequest"
  });
  if ((data === null || data === void 0 ? void 0 : data.result.cards.length) === 0) {
    return /*#__PURE__*/_jsx(SearchResultsNavMarker, {
      children: /*#__PURE__*/_jsx(UsageScreenProvider, {
        subscreen: Subscreens.NO_RESULTS,
        children: /*#__PURE__*/_jsx(NoResults, {})
      })
    });
  }
  return /*#__PURE__*/_jsx(SearchResultsNavMarker, {
    children: /*#__PURE__*/_jsx(UsageScreenProvider, {
      subscreen: Subscreens.RESULTS_GRID,
      children: hasAi && !hideAi ? /*#__PURE__*/_jsx(ResultsGridWithSummary, {}) : /*#__PURE__*/_jsx(ResultsGridWithoutSummary, {})
    })
  });
}
function SearchResultsNavMarker({
  children
}) {
  const {
    collectionSlug
  } = useParams();
  return collectionSlug ? /*#__PURE__*/_jsx(NavMarker, {
    name: "COLLECTION_LOAD",
    children: children
  }) : /*#__PURE__*/_jsx(NavMarker, {
    name: "SEARCH_RESULTS_LOAD",
    children: children
  });
}